// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Efqi","label":"styles_label__2S5G5"};